import { render, staticRenderFns } from "./categoryFee.vue?vue&type=template&id=96cdca42&"
import script from "./categoryFee.vue?vue&type=script&lang=js&"
export * from "./categoryFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports